import { IssueList } from "@/components/issues/IssueList";
import { useReportIssue } from "@/components/issues/ReportIssueProvider";
import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useCan } from "@/hooks/use-can";

/**
 * Issues — everyone sees the Issues they reported; the ADMIN role also works the queue of
 * every reported Issue. Every page is viewable by every role (2026-10-08); what a role
 * sees here is scoped by the API.
 */
export function IssuesPage() {
  const { openReportIssue } = useReportIssue();
  const worksQueue = useCan("workIssueQueue");

  return (
    <PageContainer>
      <PageHeader
        eyebrow="System"
        title="Issues"
        description={
          worksQueue
            ? "Which reported issues need someone, and who has them?"
            : "Where are the issues you reported?"
        }
        actions={<Button onClick={openReportIssue}>Report an issue</Button>}
      />
      {worksQueue ? (
        <Tabs defaultValue="queue">
          <TabsList>
            <TabsTrigger value="queue">Queue</TabsTrigger>
            <TabsTrigger value="mine">Reported by me</TabsTrigger>
          </TabsList>
          <TabsContent value="queue">
            <IssueList scope="queue" />
          </TabsContent>
          <TabsContent value="mine">
            <IssueList scope="mine" />
          </TabsContent>
        </Tabs>
      ) : (
        <IssueList scope="mine" />
      )}
    </PageContainer>
  );
}
